export const AT_CHECKOUT = 'AT_CHECKOUT';
export const FUTURE_START_DATE = 'FUTURE_START_DATE';
export const RELATIVE_START_DATE = 'RELATIVE_START_DATE';